<p class="text-left text-sm">
    {{ situacao }}
  </p>
  <div class="progress">
    <div class="progress-bar" [ngClass]="(posicaoAtual == totalRegistro)? 'bg-success' :'bg-primary'"
      role="progressbar" [ngStyle]="{'width': porcento}"></div>
  </div>
